interface Props {
  onBack?: () => void;
  isSubmitting: boolean;
  nextLabel?: string;
  nextDisabled?: boolean;
}

export function StepFooter({
  onBack,
  isSubmitting,
  nextLabel = "Next",
  nextDisabled = false,
}: Props) {
  return (
    <div className="flex items-center justify-between border-t border-border pt-4">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="rounded-md border border-border bg-surface px-3 py-2 text-sm hover:bg-surface-sunken"
        >
          Back
        </button>
      ) : (
        <span />
      )}
      <button
        type="submit"
        disabled={isSubmitting || nextDisabled}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-hover disabled:opacity-50"
      >
        {isSubmitting ? "Saving…" : nextLabel}
      </button>
    </div>
  );
}
